import { render } from "./SectionLeaveManagement.vue?vue&type=template&id=c86cee04&scoped=true"
import script from "./SectionLeaveManagement.vue?vue&type=script&lang=js"
export * from "./SectionLeaveManagement.vue?vue&type=script&lang=js"

import "./SectionLeaveManagement.vue?vue&type=style&index=0&id=c86cee04&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c86cee04"]])

export default __exports__